import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of, timer } from 'rxjs';
import { filter } from 'rxjs';
import { switchMap } from 'rxjs';
import { NoOpAction } from '../actions/no-op.actions';
import { PollAction } from '../actions/poll.actions';
import { IAppState } from '../interfaces/app-state.interface';
import { LoginService } from '../services/login.service';
import { PollingService } from '../services/polling.service';

@Injectable()
export class PollEffects {
  private pollingInterval = 2147483647;

  constructor(
    private store: Store<IAppState>,
    private loginService: LoginService,
    private pollingService: PollingService,
  ) {}

  private setInterval(config) {
    this.pollingInterval = 2147483647;
  }

  private pollObservable() {
    if (!this.loginService.isLoggedIn()) {
      return of(new NoOpAction());
    }

    return timer(0, this.pollingInterval).pipe(
      filter(this.loginService.isLoggedIn),
      filter(this.pollingService.isPolling.bind(this.pollingService)),
      switchMap(() => of(new PollAction())),
    );
  }
}
